import React, { useState, useEffect, useRef } from "react";
import "../../../../../../../css/workspace.css";
import {
  Tabs,
} from "antd";
import {
  ExportOutlined,
  FullscreenExitOutlined,
} from "@ant-design/icons";
import comingSoon from "../../../../../../../images/workspace/coming-soon.png";

const IntegrationSpace = ({ expandedBox, setExpandedBox }) => {

    const { TabPane } = Tabs;
    const expandBox = (boxId) => {
        setExpandedBox(boxId);
    };
    const collapseBox = () => {
        setExpandedBox(null);
    };

    const IntegrationMessage = () => {
        return (
          <div className="integration-empty">
            <img src={comingSoon} alt="Coming Soon" />
            <h3>We’re coming with an exciting feature, just hold on</h3>
          </div>
        );
    };

    return (
        <div
          className={`flex-item-grid ${
            expandedBox === "box4" ? "expanded expanded-integration" : ""
          } ${expandedBox && expandedBox !== "box4" ? "hidden" : ""}`}
          id="box4"
        >
          <div className="fl-grid-block integration-block">
            <span className="block-name">Integration Space</span>
            <Tabs
              defaultActiveKey="1"
              type="card"
              tabBarExtraContent={
                expandedBox === "box4" ? (
                  <FullscreenExitOutlined
                    onClick={collapseBox}
                    className="tab-full-icon"
                  />
                ) : (
                  <ExportOutlined
                    onClick={() => expandBox("box4")}
                    className="tab-full-icon"
                  />
                )
              }
            >
              <TabPane tab="Integration Space" key="1">
                <IntegrationMessage />
              </TabPane>
            </Tabs>
          </div>
        </div>
      );

}
export default IntegrationSpace;